import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ItemMaster, ItemMasterCodeBatchCommand, ItemSearchCommand } from '../../models/item/item-master/item-master';

import { ApiResponse, PaginatedApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class ItemMasterProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/item';

  postItemSearch(
    dataSearch: ItemSearchCommand,
    matchAny = false,
    consumableOnly = false,
    includeInactive = false,
    excludeProductDevelopments = false,
  ): Observable<ApiResponse<PaginatedApiResponse<ItemMaster>>> {
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<ItemMaster>>>(
      `${this.baseUrl}/search?matchAny=${matchAny}&consumableOnly=${consumableOnly}&includeInactive=${includeInactive}&excludeProductDevelopments=${excludeProductDevelopments}`,
      dataSearch,
    );
  }

  getItemCodesBatch(command: ItemMasterCodeBatchCommand): Observable<ApiResponse<ItemMaster[]>> {
    return this.httpClient.post<ApiResponse<ItemMaster[]>>(`${this.baseUrl}/item-codes/batch`, command);
  }
  public getAllItems(): Observable<ApiResponse<ItemMaster[]>> {
    return this.httpClient.get<ApiResponse<ItemMaster[]>>(`${this.baseUrl}/all`);
  }
}
